// extracted by css-extract-rspack-plugin
export default {"sortButton":"ma7IJjoi4EEYoO9Y"};